import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material.module';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { HeaderComponent } from './header/header.component';
import { AuthLayoutComponent } from './auth-layout/auth-layout.component';

import { UserBarComponent } from './user-bar/user-bar.component';
import { LeftNavComponent } from './left-nav/left-nav.component';

import { NgSelectModule } from '@ng-select/ng-select';
import { EditUserDialogComponent } from '../routes/profile/edit-user-dialog/edit-user-dialog.component';
import { HeaderNotificationDialogComponent } from './header/header-notification-dialog/header-notification-dialog.component'
/**
 * @class ThemeModule
 * @memberOf AppModule
 * @description This is a module which include shared, reusable theme component of the system
 */
const COMPONENTS = [
  EditUserDialogComponent,
  HeaderNotificationDialogComponent
];
const THIRD_MODULES = [
  MaterialModule,
];
@NgModule({
  declarations: [
    ...COMPONENTS,
    AdminLayoutComponent,
    AuthLayoutComponent,
    LeftNavComponent,

    HeaderComponent,
    UserBarComponent

  ],
  exports: [CommonModule, HeaderComponent, UserBarComponent, FormsModule],
  imports: [CommonModule, SharedModule, FormsModule, ReactiveFormsModule, NgSelectModule,],
  entryComponents: [
    EditUserDialogComponent
  ]

})
export class ThemeModule { }
